export function getLogoTitle() {
  return '';
}

export function getTelTitle() {
  return 'persönlicher Kundenservice - Kalenderhaus anrufen';
}

export function getTelNummber() {
  return '02571-80 72 850';
}

export function getTelNummberLink() {
  return 'tel:+4925718072850';
}

export function getHeaderInjection() {
  return null;
}
